module.exports = __webpack_public_path__ + "static/media/icono-2.4072b73e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/gbadicionales/icono-2.svg
// module id = 752
// module chunks = 0